import { all, call } from 'redux-saga/effects';

import watchWinterSaga from './winter';

export function* promoSaga() {
  yield all([call(watchWinterSaga)]);
}
